export default class AdAdapter {
  constructor(ad) {
    this._ad = ad;
  }

  ad() {
    return this._ad;
  }

  isLinear() {
    return this.ad().isLinear();
  }

  getDuration() {
    return this.ad().getDuration();
  }

  isSkippable() {
    return this.ad().isSkippable();
  }

  getAdId() {
    return this.ad().getAdId();
  }

  getAdSystem() {
    return this.ad().getAdSystem();
  }

  getAdvertiserName() {
    return this.ad().getAdvertiserName();
  }

  getApiFramework() {
    return this.ad().getApiFramework();
  }

  getContentType() {
    return this.ad().getContentType();
  }

  getCreativeId() {
    return this.ad().getCreativeId();
  }

  getTitle() {
    return this.ad().getTitle();
  }

  getWidth() {
    return this.ad().getWidth();
  }

  getHeight() {
    return this.ad().getHeight();
  }

  getVastMediaWidth() {
    return this.ad().getVastMediaWidth();
  }

  getVastMediaHeight() {
    return this.ad().getVastMediaHeight();
  }

  getVastMediaBitrate() {
    return this.ad().getVastMediaBitrate();
  }

  getWrapperAdIds() {
    return this.ad().getWrapperAdIds();
  }

  getWrapperCreativeIds() {
    return this.ad().getWrapperCreativeIds();
  }

  getWrapperAdSystems() {
    return this.ad().getWrapperAdSystems();
  }

  getTraffickingParametersString() {
    return this.ad().getTraffickingParametersString();
  }

  getAdPodInfo() {
    return this.ad().getAdPodInfo();
  }

  getPodIndex() {
    return this.getAdPodInfo().getPodIndex();
  }

  getPodTimeOffset() {
    return this.getAdPodInfo().getTimeOffset();
  }

  getPodTotalAds() {
    return this.getAdPodInfo().getTotalAds();
  }

  getPodAdPosition() {
    return this.getAdPodInfo().getAdPosition();
  }

  getMinSuggestedDuration() {
    return this.ad().getMinSuggestedDuration();
  }

  getSkipTimeOffset() {
    return this.ad().getSkipTimeOffset();
  }

  getDealId() {
    return this.ad().getDealId();
  }
}
